/**
 * Модуль масок для введення
 */


// Коректне Введення url 
export const handleInputUrl = (refInput, addSlesh = true) => {
    const input = refInput.current;
    input.value = input.value.replace(/[^a-zA-Z0-9-_/]/g, ''); // Допустимі символи
        if (!input.value.startsWith('/')) {
            input.value = (addSlesh ? '/' : '') + input.value.replace(/^\//, '');
        }
}
  
// Коректне введення класів
export const handleInputClasses = (refInput) => {
    const input = refInput.current;
    // Зберігаємо допустимі символи: літери, цифри, пробіли, -, _
    input.value = input.value.replace(/[^a-zA-Z0-9-_ ]/g, ''); 
};
 
// Очищає назву файлу: заборонено пробіли, кирилицю, спецсимволи, path traversal
export const handleInputFileName = (refInput) => {
    const input = refInput.current;
    // Видаляємо пробіли, кирилицю, path separators та спецсимволи
    input.value = input.value.replace(
        /[А-Яа-яЁёЇїІіЄєҐґ\s\\/:\*\?"<>|]/g, 
        ''
    );
    // Блокуємо "." / ".." як ім'я
    if (input.value === '.' || input.value === '..') {
        input.value = '';
    }
    // Прибираємо провідні крапки на кшталт "../x" залишки
    input.value = input.value.replace(/^\.+/, (m) => (m.length >= 2 ? '' : m));
};

// Коректне введення тільки англійських літер і ком
export const handleLettersAndCommaInput = (refInput) => {
    const input = refInput.current;
    // Залишаємо лише англійські літери та кому
    input.value = input.value.replace(/[^a-zA-Z,]/g, '');
};


// Форматування у вигляді "AB,CD,EF,"
export const handleTwoLettersCommaFormat = (refInput) => {
    const input = refInput.current;

    // Залишаємо тільки англійські літери
    const lettersOnly = input.value.replace(/[^a-zA-Z]/g, '');

    // Розбиваємо по 2 символи
    const chunks = lettersOnly.match(/.{1,2}/g) || [];

    // Об'єднуємо з комами
    input.value = chunks.map(chunk => chunk.toUpperCase()).join(',') + (chunks.length ? ',' : '');
};



